<template>
  <transition name="fade" mode="out-in" v-if="$vuetify.breakpoint.xsOnly">
    <router-view></router-view>
  </transition>
  <v-container fluid grid-list-xl v-else>
    <v-layout row justify-center wrap>
      <v-flex lg6 sm9 xs12>
        <transition name="fade" mode="out-in">
          <router-view></router-view>
        </transition>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {

    data: () => ({
    }),

    mounted() {
    },

    methods: {
    }
  }
</script>
